import type { BillingAccountCardWithData } from "@/modules/billing/billingCardsQuery.ts";
import type { PaymentMethodId } from "@/modules/billing/paymentMethods.ts";
import type { Translatable } from "@/modules/l10n/getTransText.ts";
import { Trans } from "@lingui/react/macro";
import { unique } from "remeda";

interface Params {
    card?: BillingAccountCardWithData;
    methodId?: PaymentMethodId;
}

/** NB: Prefer {@link byCardGateway} for localization */
export function extractCardGatewayName({ card, methodId }: Params) {
    const rawName = methodId ? methodId.split("::")[0] : (card?.processor?.keyword ?? "");
    return getCardGatewayNameFromKeywordOrId(rawName);
}

export function byCardGateway(p: Params): Translatable | undefined {
    const gatewayName = extractCardGatewayName(p);
    return gatewayName ? (
        <Trans comment="{payment method} provided by {payment gateway name}">by {gatewayName}</Trans>
    ) : undefined;
}

function getCardGatewayNameFromKeywordOrId(keywordOrId: string): string {
    // return value ONLY when we are dealing with creditcard processor (NOT for paypal saved accounts)
    if (!keywordOrId.includes("_creditcard")) {
        return "";
    }
    const name = keywordOrId.replace("_creditcard", "");
    return name.charAt(0).toUpperCase() + name.slice(1);
}

export function getShowCardGatewayInfo(gatewayKeywordsOrCardIds: string[]): boolean {
    // Show only if more than one gateway is present (excluding PayPal accounts)
    return unique(gatewayKeywordsOrCardIds.map((id) => getCardGatewayNameFromKeywordOrId(id))).length > 1;
}
